import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { createSubscription, freeSubscribe } from "../services/LoginService";

const SubscriptionPlans = ({ token, codePromo = null }) => {
    const [billing, setBilling] = useState("monthly");
    const [loadingPlan, setLoadingPlan] = useState(false);

    const basicPrice = 0;
    const proPrice = 10.99;
    const businessPrice = 20.99;

    const getPrice = (plan) => {
        switch (plan) {
            case "basic":
                return "0.00";
            case "pro":
                if (codePromo && billing === "monthly") return "9.99";
                return billing === "yearly" ? (proPrice * 12 * 0.9).toFixed(2) : proPrice.toFixed(2);
            case "business":
                if (codePromo && billing === "monthly") return "19.99";
                return billing === "yearly" ? (businessPrice * 12 * 0.9).toFixed(2) : businessPrice.toFixed(2);
            default:
                return "0.00";
        }
    };

    const handleSubscribe = async (plan) => {
        setLoadingPlan(true);
        try {
            if (plan === "basic") {
                const res = await freeSubscribe(plan, billing, token);
                alert(res.message);
            } else {
                const res = await createSubscription(plan, billing, token, codePromo);
                if (res.success && res.checkout_url) {
                    window.location.href = res.checkout_url;
                } else {
                    alert("Erreur abonnement : " + res.message);
                }
            }
        } catch (err) {
            console.error("Erreur abonnement:", err);
            alert("Erreur abonnement : " + err.message);
        }
        setLoadingPlan(false);
    };

    const handleFreeSubscribe = async () => {
        await handleSubscribe("basic");
    };

    return (
        <div className="lg:p-8">
            <h2 className="lg:text-4xl text-2xl font-extrabold lg:mb-6 mb-2 w-full text-left lg:text-center text-blue-800">
                Nos Plans d'Abonnement
            </h2>

            {/* Toggle desktop */}
            <div className="hidden lg:flex justify-center mb-8 gap-4">
                <button
                    className={`px-4 py-2 rounded-full border ${billing === "monthly" ? "bg-blue-800 text-white" : "bg-blue-200 text-blue-800"}`}
                    onClick={() => setBilling("monthly")}
                >
                    Mensuelle
                </button>
                <button
                    className={`px-4 py-2 rounded-full border ${billing === "yearly" ? "bg-blue-800 text-white" : "bg-blue-200 text-blue-800"}`}
                    onClick={() => setBilling("yearly")}
                >
                    Annuelle (-10%)
                </button>
            </div>

            <div className="flex lg:flex-row flex-col justify-center w-full gap-10 py-5 mb-10">
                {/* Basic */}
                <div className="h-[550px] lg:w-[400px] w-full border-[1px] shadow-lg bg-color2 flex flex-col justify-between border-color5 rounded-xl gap-5 p-5">
                    <div className="flex flex-col items-center gap-2">
                        <p className="text-blue-800 text-4xl font-bold font-Poppins">Basic</p>
                        <p className="text-blue-700 lg:text-xl text-center text-lg font-semibold font-Poppins">
                            Faites un essai et testez vos super-pouvoirs
                        </p>
                        <p className="text-blue-600 lg:text-xl text-md font-semibold font-Poppins">
                            € / {billing === "monthly" ? "mois" : "an"}
                        </p>
                        <p className="text-blue-800 lg:text-5xl text-5xl font-semibold font-Poppins">{getPrice("basic")}</p>
                    </div>

                    <div className="flex flex-col items-start gap-3 text-blue-600 justify-start w-full rounded-xl py-5 lg:px-5 px-1 bg-color22">
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>2 factures/devis par mois</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>1 client max</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Relances manuelles seulement</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Support par email (réponse sous 48h)</p>
                        </div>
                    </div>

                    <p
                        onClick={handleFreeSubscribe}
                        className={`text-lg font-Poppins py-2 rounded-md text-center cursor-pointer ${loadingPlan ? "bg-gray-400 text-blue-200 pointer-events-none" : "bg-white text-color3"
                            }`}
                    >
                        {loadingPlan ? "..." : "S'inscrire gratuitement"}
                    </p>
                </div>

                {/* Pro */}
                <div className="relative h-[575px] lg:w-[400px] w-full border-[1px] shadow-lg bg-color20 flex flex-col justify-between border-color5 rounded-xl gap-5 p-5 -mt-6">
                    <div className="absolute top-3 left-3 bg-yellow-400 text-white font-bold px-3 py-1 rounded-full text-xs shadow-md">Populaire</div>
                    {(billing === "yearly" || codePromo) && (
                        <div className="absolute top-2 right-3 bg-red-600 text-white font-bold px-3 py-1 rounded-full text-xs shadow-md">
                            {codePromo && billing === "monthly" ? "-10% premier mois" : "-10%"}
                        </div>
                    )}
                    <div className="flex flex-col items-center gap-2 mt-2">
                        <p className="text-color2 text-4xl font-bold font-Poppins">Pro</p>
                        <p className="text-color2 lg:text-xl text-center text-lg font-semibold font-Poppins">Expérimentez la puissance</p>
                        <p className="text-color2 lg:text-xl text-md font-semibold font-Poppins">€ / {billing === "monthly" ? "mois" : "an"}</p>
                        <p className="text-color2 text-5xl font-semibold font-Poppins">{getPrice("pro")}</p>
                    </div>

                    <div className="flex flex-col items-start gap-3 justify-start text-blue-600 w-full rounded-xl py-5 lg:px-5 px-1 bg-color2">
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Factures, devis et clients illimités</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Relances manuelle et automatique</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Exporter données Exel/CSV</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Personnalisation PDF</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Support par email (réponse sous 24h)</p>
                        </div>
                    </div>

                    <p
                        onClick={() => handleSubscribe("pro")}
                        className={`text-lg font-Poppins py-2 rounded-md text-center cursor-pointer ${loadingPlan ? "bg-gray-400 text-blue-200 pointer-events-none" : "bg-color3 text-color2"
                            }`}
                    >
                        {loadingPlan ? "..." : "Passer à Pro"}
                    </p>
                </div>

                {/* Business */}
                <div className="relative h-[555px] lg:w-[400px] w-full border-[1px] shadow-lg bg-color2 flex flex-col justify-between border-color5 rounded-xl gap-5 p-5 -mt-6">
                    {(billing === "yearly" || codePromo) && (
                        <div className="absolute top-2 right-3 bg-red-600 text-white font-bold px-3 py-1 rounded-full text-xs shadow-md">
                            {codePromo && billing === "monthly" ? "-10% premier mois" : "-10%"}
                        </div>
                    )}
                    <div className="flex flex-col items-center gap-2 mt-2">
                        <p className="text-blue-800 text-4xl font-bold font-Poppins">Business</p>
                        <p className="text-blue-700 lg:text-xl text-center text-lg font-semibold font-Poppins">
                            Prenez le contrôle de votre business, concentrez-vous sur l’essentiel
                        </p>
                        <p className="text-blue-600 lg:text-xl text-md font-semibold font-Poppins">€ / {billing === "monthly" ? "mois" : "an"}</p>
                        <p className="text-blue-800 text-5xl font-semibold font-Poppins">{getPrice("business")}</p>
                    </div>

                    <div className="flex flex-col items-start text-blue-600 gap-3 justify-start w-full rounded-xl py-5 lg:px-5 px-1 bg-color22">
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Tout le plan Pro</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Invitez votre comptable</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Intégration chat en direct</p>
                        </div>
                    </div>

                    <p
                        onClick={() => handleSubscribe("business")}
                        className={`text-lg font-Poppins py-2 rounded-md text-center cursor-pointer ${loadingPlan ? "bg-gray-400 text-blue-200 pointer-events-none" : "bg-white text-color3"
                            }`}
                    >
                        {loadingPlan ? "..." : "Passer à Business"}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPlans;
